import React from "react";
import PropTypes from "prop-types";
import "react-resizable/css/styles.css";
import BarChart from "./Charts/BarChart";
import PieChart from "./Charts/PieChart";
import LineChart from "./Charts/LineChart";
import { getColumns } from "../../editors/Statistics/StatEditor";

export default class DataChart extends React.Component {

    static propTypes = {
        // an array containing all the possible value fields (represented as bars, pies, lines etc.)
        valueFields: PropTypes.array,
        // an array containing all the possible fields for ordering the data (the X axis for ordered charts, e. g. LineChart, AreaChart)
        orderFields: PropTypes.array,
    }

    presetColors = [
        "#e60049",
        "#0bb4ff",
        "#50e991",
        "#e6d800",
        "#9b19f5",
        "#ffa300",
        "#dc0ab4",
        "#b3d4ff",
        "#00bfa0",
    ];

    chartTypes = {
        "BarChart": BarChart,
        "PieChart": PieChart,
        "LineChart": LineChart,
    }

    constructor(props) {
        super(props);
        this.state = {
            colors: this.presetColors
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.value.length > this.state.colors.length) {
            let newColors = [];
            for (let i = this.state.colors.length; i <= this.props.value.length; i++) {
                newColors.push(getRandomHexColor());
            }
            this.setState({
                colors: [...this.state.colors, ...newColors],
            });
        }
    }

    render() {
        // columns contains the actual view, valueFields contains the possible columns
        const columns = this.props.columns || this.props.valueFields;
        const visibleData = (this.props.valueFields || []).filter(fieldName => columns.includes(fieldName));
        const orderField = (this.props.orderFields || []).find(fieldName => columns.includes(fieldName));
        
        // recharts needs the data to be integer to calculate the YAxis domain correctly...
        this.props.value.length > 0 && visibleData.map((fieldName) => {
            this.props.value.map((data) => {
                let int = Number.parseInt(data[fieldName]);
                if (int !== NaN) {
                    data[fieldName] = int;
                }
            });
        })

        const Type = this.chartTypes[this.props.chartType || "BarChart"];
        return (
            <Type 
                {...this.props}
                visibleData={visibleData}
                orderField={orderField}
                columnSettings={getColumns(columns.reduce((acc,curr) => (acc[curr]='',acc),{}))}
                colors={this.state.colors}
            />
        );
    }
}

export function getRandomHexColor() {
    return "#" + Math.floor(Math.random() * 0xFFFFFF).toString(16);
}

export class ChartLoader extends React.Component {
    render() {
        return 	<div className="loading-chart-wrapper">
            <div className="loading-chart">
                <div className="loading-chart-bar-1"></div>
                <div className="loading-chart-bar-2"></div>
                <div className="loading-chart-bar-3"></div>
                <div className="loading-chart-bar-4"></div>
            </div>
        </div>;
    }
}